/* Site Loader */
var header = document.querySelector("header");


/* Header Scroll */
var banner = document.querySelector(".banner");
var prevScrollposH = window.pageYOffset;

if (banner) {
    if (window.pageYOffset < (banner.clientHeight - (header.clientHeight / 2))) {
        header.classList.add("scroll");
    }

    window.onscroll = function () {
        var currentScrollPosH = window.pageYOffset;
        if (currentScrollPosH > (banner.clientHeight - (header.clientHeight / 2))) {
            header.classList.remove("scroll");
        } else {
            header.classList.add("scroll");
        }
        prevScrollposH = currentScrollPosH;
    }
}


/* Cart Checkout Redirect */
var clink = document.querySelector("#go-cart-checkout");
var cshop = document.querySelector("#go-cart-shopping");

if (clink) {
    var clinkUrl = clink.getAttribute("data-link");
    cshop.href = clinkUrl;
}


/* Swiper Initialiser */
const swiperGallery = document.querySelectorAll(".swiper-gallery");

for (var i = 0, all = swiperGallery.length; i < all; i++) {
    if (swiperGallery) {
        swiperGallery[i].classList.add("swiperG" + i);
    }
    const nextChild = swiperGallery[i].querySelector(".swiper-button-next");
    const prevChild = swiperGallery[i].querySelector(".swiper-button-prev");
    if (nextChild) {
        nextChild.classList.add("nextG" + i);
    }
    if (prevChild) {
        prevChild.classList.add("prevG" + i);
    }

    var mySwiperG = new Swiper(".swiperG" + i, {
        direction: 'horizontal',
        loop: false,
        autoheight: false,
        slidesPerView: 'auto',
        // resistance: true,
        // resistanceRatio: 0.1,
        speed: 500,
        simulateTouch: true,
        grabCursor: true,
        preloadImages: false,
        centeredSlides: false,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
        mousewheel: {
            invert: false,
            forceToAxis: true,
            sensitivity: 1.2
        },
        freeMode: {
            enabled: true,
            // momentum: true,
            // momentumRatio: 0.85,
            // momentumBounce: true,
            // momentumBounceRatio: 0.15,
        },
        // touchReleaseOnEdges: true,
    });
}


/* Set Categories */
function setCat(parentBlock, category, tile, e) {
    var block = document.querySelector(parentBlock);
    var tiles = block.querySelectorAll(tile);

    if (e.currentTarget.parentNode.classList.contains("active")) {
        for (i = 0; i < tiles.length; i++) {
            tiles[i].classList.remove("hidden");
        }
        e.currentTarget.parentNode.classList.remove("active");
    } else {
        for (i = 0; i < tiles.length; i++) {
            tiles[i].classList.add("hidden");

            if (tiles[i].hasAttribute(category)) {
                tiles[i].classList.remove("hidden");
            }
        }
        e.currentTarget.parentNode.classList.add("active");
    }
}

function clearCat(parentBlock) {
    var block = document.querySelector(parentBlock);
    var tiles = block.querySelectorAll(".tile");

    for (i = 0; i < tiles.length; i++) {
        tiles[i].classList.remove("hidden");
    }
}


/* Stop Body */
var main = document.querySelector("main");
// var banner = document.querySelector(".banner");

function activeBody() {
    if (body.classList.contains("active")) {
        body.classList.remove("active");
        header.classList.remove("drawer");
    } else if (!body.classList.contains("active")) {
        body.classList.add("active");
        header.classList.add("drawer");
    }
}


/* Toggle Menu */
function toggleMenu(modalName) {
    var modalActive = document.getElementById(modalName);
    if (modalActive.classList.contains("active")) {
        body.classList.remove("active");
        header.classList.remove("menu");
        modalActive.classList.remove("active");
    } else if (!modalActive.classList.contains("active")) {
        body.classList.add("active");
        header.classList.add("menu");
        modalActive.classList.add("active");
    }
}


/* Radio Changer */
var availVar = document.querySelector(".product-variant_avail");
var pRadio = document.querySelector(".product__radio");

if (pRadio) {
    if (availVar) {
        availVar.click();
    } else {
        pRadio.click();
    }
}

function radioChanger(e, radios, price, upper, status, afterDesk, afterMob) {
    var pricing = document.querySelector(price);
    var radio = document.querySelectorAll(radios);
    var container = document.querySelector(upper);
    var afterPricingD = document.querySelector(afterDesk);
    var afterPricingM = document.querySelector(afterMob);

    for (i = 0; i < radio.length; i++) {
        radio[i].removeAttribute("checked")
    }

    e.target.setAttribute("checked", "checked");

    if (pricing) {
        pricing.innerHTML = e.target.getAttribute("data-price");
    }
    if (afterPricingD) {
        afterPricingD.innerHTML = e.target.getAttribute("data-afterpay-price");
    }
    if (afterPricingM) {
        afterPricingM.innerHTML = e.target.getAttribute("data-afterpay-price");
    }

    container.className = "product__data";
    container.classList.add(status);
}

function radioStock(e, radios, upper, status) {
    var radio = document.querySelectorAll(radios);

    for (i = 0; i < radio.length; i++) {
        radio[i].removeAttribute("checked")
    }

    e.target.setAttribute("checked", "checked");

    var container = document.querySelector(upper);
    container.className = "product__data";
    container.classList.add(status);
}


/* Modal Opener */
function toggleModal(modalName) {
    var modalActive = document.querySelector(modalName);

    if (modalActive) {
        body.classList.toggle("active");
        header.classList.toggle("active-modal");

        modalActive.classList.toggle("active-modal");
    }
}


/* Toggle Logins */
function toggleLogin(modalName) {
    var modalActive = document.querySelector(modalName);
    var modalSibs = modalActive.parentNode.querySelectorAll(".tab-content");
    if (modalSibs) {
        for (i = 0; i < modalSibs.length; i++) {
            modalSibs[i].classList.remove("active");
        }
    }
    modalActive.classList.add("active");
}


/* Close Popup */
function closePopup(modalName, cookieName) {
    var modalActive = document.getElementById(modalName);
    modalActive.classList.remove("active");

    var timeToAdd = 1000 * 60 * 60 * 24 * 7 * 4 * 6;
    var date = new Date();
    var expiryTime = parseInt(date.getTime()) + timeToAdd;
    date.setTime(expiryTime);
    var utcTime = date.toUTCString();

    document.cookie = cookieName + "=closed; expires=" + utcTime + ";";
}


/* Accordion Close */
var accContainer = document.querySelector(".header__menu-upper");
var accordions = document.querySelectorAll(".header__menu-upper li summary");

for (i = 0; i < accordions.length; i++) {
    accordions[i].addEventListener("click", () => {
        accContainer.classList.add("open");
    });
}


/* Close Details */
function closeDetails(e) {
    e.currentTarget.parentNode.removeAttribute("open");
    accContainer.classList.remove("open");
}


/* Hide Listen Heading */
var listenHead = document.querySelector(".nourish.listen h2");
var listenTracks = document.querySelectorAll(".playlist__tracks");

for (i = 0; i < listenTracks.length; i++) {
    listenTracks[i].onmouseover = function (event) {
        listenHead.classList.add("active");
    }

    listenTracks[i].onmouseout = function (event) {
        listenHead.classList.remove("active");
    }
}


/* Play Preview */
var cards = document.querySelectorAll(".card");

for (i = 0; i < cards.length; i++) {
    var cardV = cards[i].querySelector("video");

    if (cardV) {
        cards[i].onmouseover = function (event) {
            cardV.play();
        }

        cards[i].onmouseout = function (event) {
            cardV.pause();
            cardV.currentTime = 0;
        }
    }
}


/* Combined Link */
// home page
var hoverContainer = document.querySelectorAll(".image-caption");

for (i = 0; i < hoverContainer.length; i++) {
    var hoverChild = hoverContainer[i].querySelectorAll("a");
    // console.log(hoverChild,"hoverChild--");

    for (h = 0; h < hoverChild.length; h++) {
        hoverChild[h].onmouseover = function (event) {
            var hoverChild2 = this.parentNode.parentNode.querySelectorAll("a");
            // console.log(hoverChild2,"hoverChildAll--");
            for (c = 0; c < hoverChild2.length; c++) {
                hoverChild2[c].classList.add("hovered");
            }
        }

        hoverChild[h].onmouseout = function (event) {
            var hoverChild2 = this.parentNode.parentNode.querySelectorAll("a")
            for (c = 0; c < hoverChild2.length; c++) {
                hoverChild2[c].classList.remove("hovered");
            }
        }
    }
}

// journal page
var hoverContainer = document.querySelectorAll(".nourish.blog .nourish__article");

for (i = 0; i < hoverContainer.length; i++) {
    var hoverChild = hoverContainer[i].querySelectorAll("a");
    console.log('hoverChild----',hoverChild);
    for (h = 0; h < hoverChild.length; h++) {
        hoverChild[h].onmouseover = function (event) {
            // var hoverChild2 = this.parentNode.querySelectorAll("a");
            console.log('this.parentNode',this.parentNode);
            var hoverChild2 = this.parentNode.querySelector("a.nourish__image");
            var hoverChildLink = this.parentNode.querySelector("a.font_up");
            // console.log('hoverChild2---',hoverChild2);
            // for (c = 0; c < hoverChild2.length; c++) {
                // hoverChild2[c].classList.add("hovered");
                hoverChild2.classList.add("hovered");
                hoverChildLink.classList.add("hovered");
            // }
        }

        hoverChild[h].onmouseout = function (event) {
            // var hoverChild2 = this.parentNode.querySelectorAll("a");
            var hoverChild2 = this.parentNode.querySelector("a.nourish__image");
            var hoverChildLink = this.parentNode.querySelector("a.font_up");
            // for (c = 0; c < hoverChild2.length; c++) {
                // hoverChild2[c].classList.remove("hovered");
                hoverChild2.classList.remove("hovered");
                hoverChildLink.classList.remove("hovered");
            // }
        }
    }
}

var hoverContainerF = document.querySelectorAll(".featured-block");

for (i = 0; i < hoverContainerF.length; i++) {
    var hoverChild = hoverContainerF[i].querySelectorAll("a");
    for (h = 0; h < hoverChild.length; h++) {
        hoverChild[h].onmouseover = function (event) {
            var hoverChild2 = this.parentNode.querySelectorAll("a");
            for (c = 0; c < hoverChild2.length; c++) {
                hoverChild2[c].classList.add("hovered");
            }
        }

        hoverChild[h].onmouseout = function (event) {
            var hoverChild2 = this.parentNode.querySelectorAll("a");
            for (c = 0; c < hoverChild2.length; c++) {
                hoverChild2[c].classList.remove("hovered");
            }
        }
    }
}

// home page media pair
var hoverContainerP = document.querySelectorAll(".media-pair");
for (i = 0; i < hoverContainerP.length; i++) {
    var hoverChild = hoverContainerP[i].querySelectorAll("a");
    for (h = 0; h < hoverChild.length; h++) {
        hoverChild[h].onmouseover = function (event) {
            var hoverChild2 = this.parentNode.parentNode.querySelectorAll("a");
            console.log(hoverChild2,"hoverChild2--");
          
            for (c = 0; c < hoverChild2.length; c++) {
                hoverChild2[c].classList.add("hovered");
            }
        }

        hoverChild[h].onmouseout = function (event) {
            var hoverChild2 = this.parentNode.parentNode.querySelectorAll("a");
            for (c = 0; c < hoverChild2.length; c++) {
                hoverChild2[c].classList.remove("hovered");
            }
        }
    }
}

var hoverContainerP = document.querySelectorAll(".featured-blog__info");

for (i = 0; i < hoverContainerP.length; i++) {
    var hoverChild = hoverContainerP[i].querySelectorAll("a");
    for (h = 0; h < hoverChild.length; h++) {
        hoverChild[h].onmouseover = function (event) {
            var hoverChild2 = this.parentNode.querySelectorAll("a");
            for (c = 0; c < hoverChild2.length; c++) {
                hoverChild2[c].classList.add("hovered");
            }
        }

        hoverChild[h].onmouseout = function (event) {
            var hoverChild2 = this.parentNode.querySelectorAll("a");
            for (c = 0; c < hoverChild2.length; c++) {
                hoverChild2[c].classList.remove("hovered");
            }
        }
    }
}


/* Materials Opener */
function toggleMaterial(modalName, section) {
    var sectionActive = document.querySelectorAll(section);
    var modalActive = document.getElementById(modalName);
    const partList = document.querySelector(".studio__materials ul");
    var plHeight = partList.clientHeight;

    if (modalActive.classList.contains("active")) {
        modalActive.classList.remove("active");
        partList.parentNode.style.height = plHeight + "px";

    } else {
        if (sectionActive) {
            for (i = 0; i < sectionActive.length; i++) {
                sectionActive[i].classList.remove("active");
            }
        }
        modalActive.classList.add("active");

        const partImg = modalActive.querySelector(".studio__image-materials");

        if (section.clientHeight > partImg.clientHeight) {
            var pHeight = section.clientHeight;
        } else {
            var pHeight = partImg.clientHeight;
        }

        if (partList.parentNode.clientHeight < pHeight) {
            partList.parentNode.style.height = pHeight + "px";
            partList.parentNode.style.maxHeight = pHeight + "px";
        }

    }
}


/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({});